import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchJSON } from 'api/fetch';
import { captureException } from 'fe-core/util/errorTracking';

export const fetchSchedulePath = ({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}) =>
  `/schedule_builder/schedule/?` +
  `end_date=${endDate}&start_date=${startDate}`;

export const fetchSchedule = createAsyncThunk(
  'resource/schedule/fetch',
  async ({ startDate, endDate }: { startDate: string; endDate: string }) => {
    try {
      const response = await fetchJSON(
        fetchSchedulePath({
          startDate: startDate as string,
          endDate: endDate as string,
        })
      );
      return response;
    } catch (error) {
      // Ignore JSON parse errors for invalid auth responses
      if (
        error instanceof SyntaxError &&
        error.message.includes('is not valid JSON')
      ) {
        return;
      }

      captureException(error);
    }
  }
);
